import * as React from "react";
import * as S from "@styled";
import { connect } from "react-redux";

import { ApiSpecOperationId, ApiSpecOperationSelectModelBySpec, getApiSpecOperationSelectorModel } from "../../model/ApiSpecOperationSelectorModel";
import { State } from "../../model/State";

import { filter } from "../TypeSelector";

import { DispatchType } from "../../../shared/utilities";
import { initApiTrigger } from "../../actions/UpdateParameter";

import Select from "shared/components/select/Select";
import { GroupBase } from "react-select";
import { Option } from "shared/model/Option";

const ApiSpecOperationSelector: React.FC<ApiSpecOperationSelectorProps> = (props) => {

    const handleChange = (entry: any) => {
        const selectedId = entry.value as ApiSpecOperationId;
        props.onSelectOp(selectedId.specId, selectedId.pathKey, selectedId.method);
    };

    return (
        <S.FormGroup>
            <Select
                isClearable={false}
                placeholder={FRENDS.Localizations.SelectApiOperation}
                value={null}
                classNamePrefix="react-select"
                options={props.specSelectModel as Array<GroupBase<Option>>}
                filterOption={filter}
                onChange={handleChange}
                isDisabled={props.disabled}
            />
        </S.FormGroup>
    );
};

export interface ApiSpecOperationSelectorOwnProps {
    id: string;
}

export interface ApiSpecOperationSelectorStateProps {
    selectedTriggerTypeId: string | undefined;
    specSelectModel: ApiSpecOperationSelectModelBySpec[];
    disabled?: boolean;
}

export interface ApiSpecOperationSelectorDispatchProps {
    onSelectOp(specId: number, path: string, method: string): void;
}

type ApiSpecOperationSelectorProps = ApiSpecOperationSelectorOwnProps & ApiSpecOperationSelectorStateProps & ApiSpecOperationSelectorDispatchProps;

const mapSelectorStateToProps = (state: State, ownProps: ApiSpecOperationSelectorOwnProps): ApiSpecOperationSelectorStateProps => {
    return {
        selectedTriggerTypeId: state.elements[ownProps.id].selectedTypeId,
        specSelectModel: getApiSpecOperationSelectorModel(state),
        disabled: state.uiState.disableEdit
    };
};

const mapSelectorActionsToProps = (dispatch: DispatchType<State>, ownProps: ApiSpecOperationSelectorOwnProps): ApiSpecOperationSelectorDispatchProps => {
    return {
        onSelectOp: (specId: number, path: string, method: string) => (dispatch(initApiTrigger(ownProps.id, specId, path, method))),
    };
};

export default connect(mapSelectorStateToProps, mapSelectorActionsToProps)(ApiSpecOperationSelector);
